// extracted by mini-css-extract-plugin
module.exports = {"map":"MapComponent_map__1Jhnf","MapButton":"MapComponent_MapButton__3g2Ok"};